import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import isMobile from 'ismobilejs';
import decode from 'jwt-decode';
import cookie from 'js-cookie';
import {
  Divider,
  ListItemText,
  ListItem,
  List,
  Drawer,
  Typography,
  IconButton,
  Tab,
  Tabs,
  AppBar,
} from '@material-ui/core';
import { Menu, ChevronLeft, Home, ShoppingCart, Timeline, Face, ViewDay } from '@material-ui/icons';
import SelectSupplierModal from './modals/SelectSupplierModal';
import { getAuthToken } from './authentication/Authentication';
import { cognitoLogOut, getMarketplaceSuppliers } from '../api';

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },

  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
  },

  flexContainer: {
    display: 'flex',
  },

  listItem: {
    textAlign: 'center',
  },

  list: {
    width: 200,
  },
  onceitIcon: {
    height: '30px',
    marginRight: '15px',
    marginTop: '10px',
  },
});

class Navigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      isMobile: false,
      sideBarOpen: false,
      isSelectSupplier: false,
      currentSupplierId: null,
      currentSupplierName: null,
      suppliers: [],
      isAllowSwitchSupplier: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.isMobile = this.isMobile.bind(this);
    this.toggleSideBar = this.toggleSideBar.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onSwitchSupplier = this.onSwitchSupplier.bind(this);
    this.onSelectSupplier = this.onSelectSupplier.bind(this);
    this.onCloseSwitchSupplier = this.onCloseSwitchSupplier.bind(this);
  }

  componentWillMount() {
    this.getAllMarketPlaceSuppliers();
    const decodedJwt = decode(getAuthToken('id_token'));
    const isAllowSwitchSupplier = decodedJwt['custom:is_allow_switch_sup'] === 'true';
    const supplierName = decodedJwt['custom:supplier_name'];
    const supplierId = decodedJwt['custom:supplier_id'];

    // If not allow to switch supplier or can not get currentSupplierId from cookie, then set the value from jwt
    if (!isAllowSwitchSupplier || !cookie.get('currentSupplierId')) {
      const supplier = this.state.suppliers.filter(item => item.id === supplierId);
      if (supplier && supplier[0]) {
        this.setState({ currentSupplierName: supplier[0].name });
      }
      this.setState({
        currentSupplierId: Number(supplierId),
        currentSupplierName: supplierName,
        isAllowSwitchSupplier,
      });
      cookie.set('currentSupplierId', Number(supplierId), {
        expires: 1,
        path: window.location.hostname,
      });
      cookie.set('currentSupplierName', supplierName, {
        expires: 1,
        path: window.location.hostname,
      });
    } else {
      this.setState({
        currentSupplierId: Number(cookie.get('currentSupplierId')),
        currentSupplierName: cookie.get('currentSupplierName'),
        isAllowSwitchSupplier,
      });
    }
  }

  componentDidMount() {
    if (window.location.hash === '#/orders') {
      this.setState({
        value: 2,
      });
    } else if (window.location.hash === '#/statements') {
      this.setState({
        value: 3,
      });
    } else if (window.location.hash === '#/products') {
      this.setState({
        value: 4,
      });
    } else {
      this.setState({
        value: 1,
      });
    }

    window.addEventListener('resize', this.isMobile);
  }

  getAllMarketPlaceSuppliers() {
    getMarketplaceSuppliers().then(suppliers => {
      if (suppliers) {
        this.setState({ suppliers });
      }
    });
  }

  handleChange(event, value) {
    this.setState({ value });
  }

  isMobile() {
    if (window.innerWidth < 850) {
      this.setState({ isMobile: true });
    } else {
      this.setState({ isMobile: false });
    }
  }

  onClick(value) {
    this.context.router.history.push(value);
  }

  onSelectSupplier(supplierId) {
    const supplier = this.state.suppliers.filter(item => item.id === supplierId);
    if (supplier && supplier[0]) {
      this.setState({ currentSupplierName: supplier[0].name });
    }
    this.setState({ currentSupplierId: supplierId });
    cookie.set('currentSupplierId', supplierId, {
      expires: 1,
      path: window.location.hostname,
    });
    cookie.set('currentSupplierName', supplier[0].name, {
      expires: 1,
      path: window.location.hostname,
    });
    this.onCloseSwitchSupplier();
    window.location.reload();
  }

  onSwitchSupplier() {
    this.setState({ isSelectSupplier: true });
  }

  onCloseSwitchSupplier() {
    this.setState({ isSelectSupplier: false });
  }

  toggleSideBar(open) {
    this.setState({
      sideBarOpen: open,
    });
  }

  render() {
    const { classes } = this.props;
    const {
      value,
      isSelectSupplier,
      currentSupplierId,
      currentSupplierName,
      suppliers,
      isAllowSwitchSupplier,
    } = this.state;
    return (
      <div className={classes.root}>
        <AppBar className="app-bar" position="fixed">
          {!isMobile.phone ? (
            <Tabs
              value={value}
              classes={{ flexContainer: classes.flexContainer }}
              indicatorColor="secondary"
              onChange={this.handleChange}
            >
              <img src="logo-dark.svg" className="onceit-logo" />
              <Tab label="Home" component={Link} to="/" />
              <Tab label="Orders" component={Link} to="/orders" />
              <Tab label="Statements" component={Link} to="/statements" />
              <Tab label="Products" component={Link} to="/products" />
              <div className="logo-container">
                <Tab textColorPrimary label={currentSupplierName} disabled />

                <div className="account-container">
                  {isAllowSwitchSupplier && (
                    <img
                      src="images/switch.svg"
                      className={classes.onceitIcon}
                      onClick={() => this.onSwitchSupplier()}
                    />
                  )}
                  <img
                    src="images/logout.svg"
                    className={classes.onceitIcon}
                    onClick={() => cognitoLogOut()}
                  />
                </div>
              </div>
            </Tabs>
          ) : (
            <div>
              <IconButton onClick={() => this.toggleSideBar('true')}>
                <Menu />
              </IconButton>
              <img src="logo-dark.svg" className="onceit-logo" />
              {this.state.sideBarOpen ? (
                <Drawer open={this.state.sideBarOpen} onClose={() => this.toggleSideBar(false)}>
                  <div className={classes.list}>
                    <List onClick={() => this.toggleSideBar(false)}>
                      <div className={classes.drawerHeader}>
                        <IconButton onClick={() => this.toggleSideBar(false)}>
                          <ChevronLeft />
                        </IconButton>
                      </div>
                      <Divider />
                      <ListItem button component={Link} to="/">
                        <Home />
                        <ListItemText classes={classes.listItem} primary="Home" />
                      </ListItem>
                      <ListItem button component={Link} to="/orders">
                        <Timeline />
                        <ListItemText primary="Orders" />
                      </ListItem>
                      <ListItem button component={Link} to="/statements">
                        <ViewDay />
                        <ListItemText primary="Statements" />
                      </ListItem>

                      <ListItem button>
                        <ShoppingCart />
                        <ListItemText primary="Products" />
                      </ListItem>
                      <ListItem button onClick={() => cognitoLogOut()}>
                        <Face />
                        <ListItemText primary="Log Out" />
                      </ListItem>
                      <Divider />
                    </List>
                  </div>
                </Drawer>
              ) : null}
            </div>
          )}
          <div />
        </AppBar>
        {isSelectSupplier && (
          <SelectSupplierModal
            currentSupplierId={currentSupplierId}
            suppliers={suppliers}
            onClose={this.onCloseSwitchSupplier}
            onSubmit={this.onSelectSupplier}
          />
        )}
      </div>
    );
  }
}

Navigation.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Navigation);



// WEBPACK FOOTER //
// ./src/components/MenuBar.jsx